import { Base, Component, Prop } from '@/vue-property-decorator'
import { Empty } from '@/plugins/ant-design-vue/tsx-support'
import { EmptyImageGame } from '@/components/business-components/empty-image'
import { useGameStore } from '@/views/game/store'
import { useI18n } from '@/i18n'
import style from './style.module.scss'

@Component<OccupiedEmpty>({
  name: 'OccupiedEmpty'
})
export default class OccupiedEmpty extends Base<
  unknown,
  { description?: string },
  unknown
> {
  @Prop()
  private description!: string
  render() {
    const { t } = useI18n()
    const { gameListLoading } = useGameStore()
    return gameListLoading ? (
      <div class={style.empty} />
    ) : (
      <Empty.Tsx
        class={style.empty}
        description={this.description || (t('lobby.game.empty') as string)}
        image={<EmptyImageGame />}
      />
    )
  }
}
